// ---------------------------------------------------------------------------------------------------

function path(root, sublink) {
    return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_MAIN = '/main';
const ROOTS_DEALER = '/dealer';
const ROOTS_JJMIUser = '/jjmiuser';
const ROOTS_SkpUser = '/skpuser';
const ROOTS_Admin = '/helpadmin';
const ROOTS_CoE = '/coe';
const ROOTS_SalesUser = '/salesuser';
const ROOTS_ManagerUser = '/manageruser';
const ROOTS_DashboardParam = '/dashboardparam';
const ROOTS_HelpAndCommunication = '/helpandcommunication';
const ROOTS_NetRetail = '/netretaillayout';
const ROOTS_Supervisor = '/supervisor';
const ROOTS_NSM = '/nsm';
const ROOTS_BS = '/setmanagementb';
const ROOTS_SETDEALER = '/setdealer';
const ROOTS_BRANCHSECRETARY = '/branchsecretary';
const ROOTS_AllPages = '/allpages';
const ROOTS_ReportUser = '/reportuser';
const ROOTS_DashboardAndReportUser = '/dashboardandreportuser';
const ROOTS_MasterUser = '/masteruser';
const ROOTS_MasterViewer = '/masterviewer';
// ----------------------------------------------------------------------------------------------------

export const PATH_AUTH = {
    login: '/login',
};

export const PATH_EntLogin = {
    entgatelogin: '/entgatelogin',
};

export const PATH_LOGOUT = {
    logout: '/logout',
};

export const PATH_COMMON = {
    common: '/commonpage',
};

export const PATH_SetManagement = {
    common: '/setmanagement',
};

export const PATH_COMMING = {
    comming: '/commingsoonpage',
};

export const PATH_MAIN = {
    root: path(ROOTS_MAIN, '/master'),

    subroot: (mainMasterName, subMasterName) => path(ROOTS_MAIN, `/${mainMasterName}/${subMasterName}`),

    importStepOne: (mainMasterName, subMasterName) => path(ROOTS_MAIN, `/${mainMasterName}/${subMasterName}/stepone`),

    importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_MAIN, `/${mainMasterName}/${subMasterName}/stepthree`),

    master: {
        // Masters
        root: path(ROOTS_MAIN, '/master'),
        //  subroot: (masterName) => path(ROOTS_MAIN, `/master/${masterName}`),
        product: path(ROOTS_MAIN, '/master/product'),
        distributor: path(ROOTS_MAIN, '/master/distributor'),
        account: path(ROOTS_MAIN, '/master/account'),
        surgeon: path(ROOTS_MAIN, '/master/surgeon'),
        areatree: path(ROOTS_MAIN, '/master/areatree'),
        saleshierarchy: path(ROOTS_MAIN, '/master/saleshierarchy'),
        netrealizationrate: path(ROOTS_MAIN, '/master/nrr'),
        fieldstaffallocation: path(ROOTS_MAIN, '/master/fieldstaffallocation'),
        empmaster: path(ROOTS_MAIN, '/master/empmaster'),
        empterritory: path(ROOTS_MAIN, '/master/empterritory'),
        accountterritory: path(ROOTS_MAIN, '/master/accountterritory'),
        territoryhierarchy: path(ROOTS_MAIN, '/master/territoryhierarchy'),
        orggroupdefinition: path(ROOTS_MAIN, '/master/orggroupdefinition'),
        dealeragreementexpiry: path(ROOTS_MAIN, '/master/dealeragreementexpiry'),
        dealerrating: path(ROOTS_MAIN, '/master/dealerrating'),
        standardpricemaster: path(ROOTS_MAIN, '/master/standardpricemaster'),
        distributorbillingsoftware: path(ROOTS_MAIN, '/master/distributorbillingsoftware'),

        // user: path(ROOTS_MAIN, '/master/usermaster'),
        usermasterlist: path(ROOTS_MAIN, '/master/usermasterlist'),
        userdata: path(ROOTS_MAIN, '/master/userdata'),
        customersalesteam: path(ROOTS_MAIN, '/master/customersalesteam'),
        useraccessrights: path(ROOTS_MAIN, '/master/useraccessrights'),
    },

    alliedmaster: {
        // Allied masters
        root: path(ROOTS_MAIN, '/alliedmaster'),
        //  subroot: (masterName) => path(ROOTS_MAIN, `/alliedmaster/${masterName}`),

        distributorgroup: path(ROOTS_MAIN, '/alliedmaster/distributorgroup'),
        uom: path(ROOTS_MAIN, '/alliedmaster/uom'),
        franchise: path(ROOTS_MAIN, '/alliedmaster/franchise'),
        subfranchise: path(ROOTS_MAIN, '/alliedmaster/subfranchise'),
        productgroup: path(ROOTS_MAIN, '/alliedmaster/productgroup'),
        productcategory: path(ROOTS_MAIN, '/alliedmaster/productcategory'),
        productbrand: path(ROOTS_MAIN, '/alliedmaster/productbrand'),
        productline: path(ROOTS_MAIN, '/alliedmaster/productline'),
        accountgroup: path(ROOTS_MAIN, '/alliedmaster/accountgroup'),
        accounttype: path(ROOTS_MAIN, '/alliedmaster/accounttype'),
        accountclassification: path(ROOTS_MAIN, '/alliedmaster/accountclassification'),
        accountsegmentation: path(ROOTS_MAIN, '/alliedmaster/accountsegmentation'),
        surgeoncontacttype: path(ROOTS_MAIN, '/alliedmaster/surgeoncontacttype'),
        surgeonsubcontacttype: path(ROOTS_MAIN, '/alliedmaster/surgeonsubcontacttype'),
        citytier: path(ROOTS_MAIN, '/alliedmaster/citytier'),
        territory: path(ROOTS_MAIN, '/alliedmaster/territory'),
        emplevel: path(ROOTS_MAIN, '/alliedmaster/emplevel'),
        specialist: path(ROOTS_MAIN, '/alliedmaster/specialist'),
    },

    // configuration
    configuration: path(ROOTS_MAIN, '/configuration'),
    cutoffdatepage: path(ROOTS_MAIN, '/cutoffdatepage'),

    /*  configuration: {
          // configuration
          root: path(ROOTS_MAIN, '/configuration'),
          datauploadtemplatemapping: path(ROOTS_MAIN, '/configuration/datauploadtemplatemapping'),
          snstemplatemapping: path(ROOTS_MAIN, '/configuration/snstemplatemapping'),
      },  */
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    one: path(ROOTS_DASHBOARD, '/one'),
    two: path(ROOTS_DASHBOARD, '/two'),
    three: path(ROOTS_DASHBOARD, '/three'),
    user: {
        root: path(ROOTS_DASHBOARD, '/user'),
        four: path(ROOTS_DASHBOARD, '/user/four'),
        five: path(ROOTS_DASHBOARD, '/user/five'),
        six: path(ROOTS_DASHBOARD, '/user/six'),
    },
};

export const PATH_DEALER = {
    //   root: (uploadName) => path(ROOTS_DEALER, `/${uploadName}`),
    root: ROOTS_DEALER,
    dashboard: path(ROOTS_DEALER, '/dashboard'),
    dataUpload: path(ROOTS_DEALER, '/dataupload'),
    snsUpload: path(ROOTS_DEALER, '/snsupload'),
    dataMapping: path(ROOTS_DEALER, '/dealerdatamapping'),
    myrequest: path(ROOTS_DEALER, '/myrequest'),
    manualdata: path(ROOTS_DEALER, '/manualdata'),
    helpdesk: path(ROOTS_DEALER, '/helpdesk'),
    //  helpandcommunication: path(ROOTS_DEALER, '/helpandcommunication'),
    settings: path(ROOTS_DEALER, '/settings'),

    dashboardparameter: path(ROOTS_DEALER, '/dashboard/dashboardparameter'),
    allproducts: path(ROOTS_DEALER, '/dashboard/allproducts'),
    allcustomers: path(ROOTS_DEALER, '/dashboard/allcustomers'),

    dataMappingForm: path(ROOTS_DEALER, '/dealerdatamappingform'),
    dealerdatamapping: path(ROOTS_DEALER, '/dealerDataUpload/datamapping'),
    // manualdatacreate: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/manualdatacreate`),

    closuremonth: path(ROOTS_DEALER, '/closuremonth'),
    closemonth: path(ROOTS_DEALER, '/closuremonth/closemonth'),

    manualdatacreate: path(ROOTS_DEALER, '/manualdata/manualdatacreate'),
    //  closemonth: path(ROOTS_DEALER, '/manualdata/closemonth'),
    viewinvoiceform: path(ROOTS_DEALER, '/manualdata/viewinvoiceform'),
    onlineentrypage2: path(ROOTS_DEALER, '/manualdata/onlineentrypage2'),
    onlineentrypage4: path(ROOTS_DEALER, '/manualdata/onlineentrypage4'),
    calender: path(ROOTS_DEALER, '/calender'),

    snsmapping: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/mapping`),
    dataMappingAccountForm: path(ROOTS_DEALER, '/datamappingaccountform'),

    uploadstepone: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/dealeruploadstepone`),
    uploadsteptwo: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/dealeruploadsteptwo`),
    datauploadv1stepone: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/datauploadv1stepone`),
    datauploadv1steptwo: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/datauploadv1steptwo`),

    uploadstepthree: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/dealeruploadstepthree`),
    unmappeddataentries: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/unmappeddataentries`),

    // DealerViewData: path(ROOTS_DEALER, '/dealersnsupload/viewdata'),
    // DealerDataUploadViewData: path(ROOTS_DEALER, '/dataupload/viewdata'),
    DealerViewData: (uploadName) => path(ROOTS_DEALER, `/${uploadName}/viewdata`),

    onlineentry3: path(ROOTS_DEALER, '/manualdata/onlineentry3'),
    onlineentry5: path(ROOTS_DEALER, '/manualdata/onlineentry5'),
    notificationpage: path(ROOTS_DEALER, '/notificationpage'),

    snsuploadstep1: path(ROOTS_DEALER, '/snsupload/snsuploadstep1'),
    snsuploadstep2: path(ROOTS_DEALER, '/snsupload/snsuploadstep2'),
    snsviewdata: path(ROOTS_DEALER, '/snsupload/snsviewdata'),

    jjconnectlink: path(ROOTS_DEALER, '/jjconnectlink'),

    data: {
        root: path(ROOTS_DEALER, '/data'),
        datapage: path(ROOTS_DEALER, '/datapage'),
        inventorypage: path(ROOTS_DEALER, '/data/inventorypage'),
        grosssalepage: path(ROOTS_DEALER, '/data/grosssalepage'),
    },
    report: {
        root: path(ROOTS_DEALER, '/report'),
        reportpage: path(ROOTS_DEALER, '/reportpage'),
        transactionreportpage: path(ROOTS_DEALER, '/report/transactionreportpage'),
        dealerreportpage: path(ROOTS_DEALER, '/report/dealerreportpage'),
        dealersnsreportpage: path(ROOTS_DEALER, '/report/dealersnsreportpage'),
        grosssalesreportpage: path(ROOTS_DEALER, '/report/grosssalesreportpage'),
        dealerreportedsnsreportpage: path(ROOTS_DEALER, '/report/dealerreportedsnsreportpage'),
        territorydumpreportpage: path(ROOTS_DEALER, '/report/territorydumpreportpage'),
    }
};

export const PATH_JJMIUser = {
    root: ROOTS_JJMIUser,
    dataUploadApprove: path(ROOTS_JJMIUser, '/datauploadapprove'),
    dataupload: path(ROOTS_JJMIUser, '/dataupload'),

    dataMappingApprove: path(ROOTS_JJMIUser, '/datamappingapprove'),
    noneligiblerecordsapprove: path(ROOTS_JJMIUser, '/noneligiblerecordsapprove'),
    datamapping: path(ROOTS_JJMIUser, '/datamapping'),
    datamappingproductpage: path(ROOTS_JJMIUser, '/datamapping/datamappingproductpage'),
    datamappingaccountpage: path(ROOTS_JJMIUser, '/datamapping/datamappingaccountpage'),
    datamappingsurgeonpage: path(ROOTS_JJMIUser, '/datamapping/datamappingsurgeonpage'),
    enablereupload: path(ROOTS_JJMIUser, '/enablereupload'),
    dealerrequest: path(ROOTS_JJMIUser, '/dealerrequest'),
    dealeraccountrequest: path(ROOTS_JJMIUser, '/dealerrequest/dealeraccountrequest'),
    dealersugeonrequest: path(ROOTS_JJMIUser, '/dealerrequest/dealersugeonrequest'),
    raiseticketrequest: path(ROOTS_JJMIUser, '/raiseticketrequest/raiseticketpage'),

};

export const PATH_SkpUser = {
    root: ROOTS_SkpUser,
    dataUploadApprove: path(ROOTS_SkpUser, '/datauploadapprove'),
    dataupload: path(ROOTS_SkpUser, '/dataupload'),
    dataMappingApprove: path(ROOTS_SkpUser, '/datamappingapprove'),
    noneligiblerecordsapprove: path(ROOTS_SkpUser, '/noneligiblerecordsapprove'),
    datamapping: path(ROOTS_SkpUser, '/datamapping'),
    datamappingproductpage: path(ROOTS_SkpUser, '/datamapping/datamappingproductpage'),
    datamappingaccountpage: path(ROOTS_SkpUser, '/datamapping/datamappingaccountpage'),
    datamappingsurgeonpage: path(ROOTS_SkpUser, '/datamapping/datamappingsurgeonpage'),
    enablereupload: path(ROOTS_SkpUser, '/enablereupload'),
    dealerrequest: path(ROOTS_SkpUser, '/dealerrequest'),
    dealeraccountrequest: path(ROOTS_SkpUser, '/dealerrequest/dealeraccountrequest'),
    dealersugeonrequest: path(ROOTS_SkpUser, '/dealerrequest/dealersugeonrequest'),
    raiseticketrequest: path(ROOTS_SkpUser, '/raiseticketrequest/raiseticketpage'),

    subroot: (mainMasterName, subMasterName) => path(ROOTS_SkpUser, `/${mainMasterName}/${subMasterName}`),

    importStepOne: (mainMasterName, subMasterName) => path(ROOTS_SkpUser, `/${mainMasterName}/${subMasterName}/stepone`),

    importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_SkpUser, `/${mainMasterName}/${subMasterName}/stepthree`),

    master: {
        // Masters
        root: path(ROOTS_SkpUser, '/master'),

        //  subroot: (masterName) => path(ROOTS_MAIN, `/master/${masterName}`),
        product: path(ROOTS_SkpUser, '/master/product'),
        distributor: path(ROOTS_SkpUser, '/master/distributor'),
        account: path(ROOTS_SkpUser, '/master/account'),
        surgeon: path(ROOTS_SkpUser, '/master/surgeon'),
        areatree: path(ROOTS_SkpUser, '/master/areatree'),
        saleshierarchy: path(ROOTS_SkpUser, '/master/saleshierarchy'),
        netrealizationrate: path(ROOTS_SkpUser, '/master/nrr'),
        fieldstaffallocation: path(ROOTS_SkpUser, '/master/fieldstaffallocation'),
        empmaster: path(ROOTS_SkpUser, '/master/empmaster'),
        empterritory: path(ROOTS_SkpUser, '/master/empterritory'),
        accountterritory: path(ROOTS_SkpUser, '/master/accountterritory'),
        territoryhierarchy: path(ROOTS_SkpUser, '/master/territoryhierarchy'),
        orggroupdefinition: path(ROOTS_SkpUser, '/master/orggroupdefinition'),
        dealeragreementexpiry: path(ROOTS_SkpUser, '/master/dealeragreementexpiry'),
        dealerrating: path(ROOTS_SkpUser, '/master/dealerrating'),
        standardpricemaster: path(ROOTS_SkpUser, '/master/standardpricemaster'),
        distributorbillingsoftware: path(ROOTS_SkpUser, '/master/distributorbillingsoftware'),

        // user: path(ROOTS_MAIN, '/master/usermaster'),
        usermasterlist: path(ROOTS_SkpUser, '/master/usermasterlist'),
        userdata: path(ROOTS_SkpUser, '/master/userdata'),
        customersalesteam: path(ROOTS_SkpUser, '/master/customersalesteam'),
        useraccessrights: path(ROOTS_SkpUser, '/master/useraccessrights'),
    },

    alliedmaster: {
        // Allied masters
        root: path(ROOTS_SkpUser, '/alliedmaster'),
        //  subroot: (masterName) => path(ROOTS_MAIN, `/alliedmaster/${masterName}`),

        distributorgroup: path(ROOTS_SkpUser, '/alliedmaster/distributorgroup'),
        uom: path(ROOTS_SkpUser, '/alliedmaster/uom'),
        franchise: path(ROOTS_SkpUser, '/alliedmaster/franchise'),
        subfranchise: path(ROOTS_SkpUser, '/alliedmaster/subfranchise'),
        productgroup: path(ROOTS_SkpUser, '/alliedmaster/productgroup'),
        productcategory: path(ROOTS_SkpUser, '/alliedmaster/productcategory'),
        productbrand: path(ROOTS_SkpUser, '/alliedmaster/productbrand'),
        productline: path(ROOTS_SkpUser, '/alliedmaster/productline'),
        accountgroup: path(ROOTS_SkpUser, '/alliedmaster/accountgroup'),
        accounttype: path(ROOTS_SkpUser, '/alliedmaster/accounttype'),
        accountclassification: path(ROOTS_SkpUser, '/alliedmaster/accountclassification'),
        accountsegmentation: path(ROOTS_SkpUser, '/alliedmaster/accountsegmentation'),
        surgeoncontacttype: path(ROOTS_SkpUser, '/alliedmaster/surgeoncontacttype'),
        surgeonsubcontacttype: path(ROOTS_SkpUser, '/alliedmaster/surgeonsubcontacttype'),
        citytier: path(ROOTS_SkpUser, '/alliedmaster/citytier'),
        territory: path(ROOTS_SkpUser, '/alliedmaster/territory'),
        emplevel: path(ROOTS_SkpUser, '/alliedmaster/emplevel'),
        specialist: path(ROOTS_SkpUser, '/alliedmaster/specialist'),
    },

    // configuration
    configuration: path(ROOTS_SkpUser, '/configuration'),
    cutoffdatepage: path(ROOTS_SkpUser, '/cutoffdatepage'),

    report: {
        root: path(ROOTS_SkpUser, '/report'),
        reportpage: path(ROOTS_SkpUser, '/reportpage'),
        transactionreportpage: path(ROOTS_SkpUser, '/report/transactionreportpage'),
        dealerreportpage: path(ROOTS_SkpUser, '/report/dealerreportpage'),
        dumpreportpage: path(ROOTS_SkpUser, '/report/dumpreportpage'),

    }

    /*  configuration: {
          // configuration
          root: path(ROOTS_MAIN, '/configuration'),
          datauploadtemplatemapping: path(ROOTS_MAIN, '/configuration/datauploadtemplatemapping'),
          snstemplatemapping: path(ROOTS_MAIN, '/configuration/snstemplatemapping'),
      },  */
};

export const PATH_CoE = {
    root: ROOTS_CoE,
    dataUploadApprove: path(ROOTS_CoE, '/datauploadapprove'),
    reloadzylemdata: path(ROOTS_CoE, '/reloadzylemdata'),
    coedataupload: path(ROOTS_CoE, '/coedataupload'),
    coedatauploadstepone: path(ROOTS_CoE, '/coedataupload/coedatauploadstepone'),
    coedatauploadsteptwo: path(ROOTS_CoE, '/coedataupload/coedatauploadsteptwo'),
    coedatauploadmain: path(ROOTS_CoE, '/coedataupload/coedatauploadmain'),
    dataupload: path(ROOTS_CoE, '/dataupload'),
    dataMappingApprove: path(ROOTS_CoE, '/datamappingapprove'),
    noneligiblerecordsapprove: path(ROOTS_CoE, '/noneligiblerecordsapprove'),
    datamapping: path(ROOTS_CoE, '/datamapping'),
    datamappingproductpage: path(ROOTS_CoE, '/datamapping/datamappingproductpage'),
    datamappingaccountpage: path(ROOTS_CoE, '/datamapping/datamappingaccountpage'),
    datamappingsurgeonpage: path(ROOTS_CoE, '/datamapping/datamappingsurgeonpage'),
    datamappingimportstep1: path(ROOTS_CoE, `/datamapping/datamappingimportstep1`),
    datamappingimportstep2: (importName) => path(ROOTS_CoE, `/datamapping/${importName}/datamappingimportstep2`),
    datamappingimportstep3: (importName) => path(ROOTS_CoE, `/datamapping/${importName}/datamappingimportstep3`),
    datamappingdownloadstep2: (importName) => path(ROOTS_CoE, `/datamapping/${importName}/datamappingdownloadstep2`),
    enablereupload: path(ROOTS_CoE, '/enablereupload'),
    dealerrequest: path(ROOTS_CoE, '/dealerrequest'),
    dealeraccountrequest: path(ROOTS_CoE, '/dealerrequest/dealeraccountrequest'),
    dealersugeonrequest: path(ROOTS_CoE, '/dealerrequest/dealersugeonrequest'),
    raiseticketrequest: path(ROOTS_CoE, '/raiseticketrequest/raiseticketpage'),

    subroot: (mainMasterName, subMasterName) => path(ROOTS_CoE, `/${mainMasterName}/${subMasterName}`),

    importStepOne: (mainMasterName, subMasterName) => path(ROOTS_CoE, `/${mainMasterName}/${subMasterName}/stepone`),

    importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_CoE, `/${mainMasterName}/${subMasterName}/stepthree`),

    master: {
        // Masters
        root: path(ROOTS_CoE, '/master'),

        //  subroot: (masterName) => path(ROOTS_MAIN, `/master/${masterName}`),
        product: path(ROOTS_CoE, '/master/product'),
        ecpproduct: path(ROOTS_CoE, '/master/ecpproduct'),
        distributor: path(ROOTS_CoE, '/master/distributor'),
        account: path(ROOTS_CoE, '/master/account'),
        surgeon: path(ROOTS_CoE, '/master/surgeon'),
        areatree: path(ROOTS_CoE, '/master/areatree'),
        saleshierarchy: path(ROOTS_CoE, '/master/saleshierarchy'),
        netrealizationrate: path(ROOTS_CoE, '/master/nrr'),
        fieldstaffallocation: path(ROOTS_CoE, '/master/fieldstaffallocation'),
        empmaster: path(ROOTS_CoE, '/master/empmaster'),
        territory: path(ROOTS_CoE, '/master/territory'),
        empterritory: path(ROOTS_CoE, '/master/empterritory'),
        empregion: path(ROOTS_CoE, '/master/empregion'),
        accountterritory: path(ROOTS_CoE, '/master/accountterritory'),
        distributorterritory: path(ROOTS_CoE, '/master/distributorterritory'),
        territoryhierarchy: path(ROOTS_CoE, '/master/territoryhierarchy'),
        orggroupdefinition: path(ROOTS_CoE, '/master/orggroupdefinition'),
        dealeragreementexpiry: path(ROOTS_CoE, '/master/dealeragreementexpiry'),
        dealerrating: path(ROOTS_CoE, '/master/dealerrating'),
        standardpricemaster: path(ROOTS_CoE, '/master/standardpricemaster'),
        distributorbillingsoftware: path(ROOTS_CoE, '/master/distributorbillingsoftware'),
        customers: path(ROOTS_CoE, '/master/customers'),
        customeraccount: path(ROOTS_CoE, '/master/customeraccount'),

        // user: path(ROOTS_MAIN, '/master/usermaster'),
        usermasterlist: path(ROOTS_CoE, '/master/usermasterlist'),
        userdata: path(ROOTS_CoE, '/master/userdata'),
        customersalesteam: path(ROOTS_CoE, '/master/customersalesteam'),
        useraccessrights: path(ROOTS_CoE, '/master/useraccessrights'),
        productvariant: path(ROOTS_CoE, '/master/productvariant'),
    },

    alliedmaster: {
        // Allied masters
        root: path(ROOTS_CoE, '/alliedmaster'),
        //  subroot: (masterName) => path(ROOTS_MAIN, `/alliedmaster/${masterName}`),

        distributorgroup: path(ROOTS_CoE, '/alliedmaster/distributorgroup'),
        uom: path(ROOTS_CoE, '/alliedmaster/uom'),
        franchise: path(ROOTS_CoE, '/alliedmaster/franchise'),
        subfranchise: path(ROOTS_CoE, '/alliedmaster/subfranchise'),
        productgroup: path(ROOTS_CoE, '/alliedmaster/productgroup'),
        productcategory: path(ROOTS_CoE, '/alliedmaster/productcategory'),
        productbrand: path(ROOTS_CoE, '/alliedmaster/productbrand'),
        productline: path(ROOTS_CoE, '/alliedmaster/productline'),
        accountgroup: path(ROOTS_CoE, '/alliedmaster/accountgroup'),
        accounttype: path(ROOTS_CoE, '/alliedmaster/accounttype'),
        accountclassification: path(ROOTS_CoE, '/alliedmaster/accountclassification'),
        accountsegmentation: path(ROOTS_CoE, '/alliedmaster/accountsegmentation'),
        accountcategory: path(ROOTS_CoE, '/alliedmaster/accountcategory'),
        surgeoncontacttype: path(ROOTS_CoE, '/alliedmaster/surgeoncontacttype'),
        surgeonsubcontacttype: path(ROOTS_CoE, '/alliedmaster/surgeonsubcontacttype'),
        citytier: path(ROOTS_CoE, '/alliedmaster/citytier'),
        // territory: path(ROOTS_CoE, '/alliedmaster/territory'),
        emplevel: path(ROOTS_CoE, '/alliedmaster/emplevel'),
        specialist: path(ROOTS_CoE, '/alliedmaster/specialist'),
        bravohierarchy: path(ROOTS_CoE, '/alliedmaster/bravohierarchy'),
    },

    // configuration
    configuration: path(ROOTS_CoE, '/configuration'),
    cutoffdatepage: path(ROOTS_CoE, '/cutoffdatepage'),
    franchisewisecutoff: path(ROOTS_CoE, '/franchisewisecutoff'),

    myreport:
    {
        root: path(ROOTS_CoE, '/myreport'),
        reportpage: path(ROOTS_CoE, '/myreportpage'),
        territorydumpreportpage: path(ROOTS_CoE, '/myreport/territorydumpreportpage'),

    },
    report: {
        root: path(ROOTS_CoE, '/report'),
        reportpage: path(ROOTS_CoE, '/reportpage'),
        transactionreportpage: path(ROOTS_CoE, '/report/transactionreportpage'),
        dealerreportpage: path(ROOTS_CoE, '/report/dealerreportpage'),
        dumpreportpage: path(ROOTS_CoE, '/report/dumpreportpage'),
        territorydumpreportpage: path(ROOTS_CoE, '/report/territorydumpreportpage'),
        dealerpurchasereportpage: path(ROOTS_CoE, '/report/dealerpurchasereportpage'),
        inventoryreportpage: path(ROOTS_CoE, '/report/inventoryreportpage'),
        activitylogpage: path(ROOTS_CoE, '/report/activitylogpage'),
        dealerdatastatusreportpage: path(ROOTS_CoE, '/report/dealerstatusdatareportpage'),
        dealerreportedsnsreportpage: path(ROOTS_CoE, '/report/dealerreportedsnsreportpage'),
        dealersnsreportpage: path(ROOTS_CoE, '/report/dealersnsreportpage'),
        grosssalesreportpage: path(ROOTS_CoE, '/report/grosssalesreportpage'),
        standardpricereportpage: path(ROOTS_CoE, '/report/standardpricereportpage'),
        moduleroleaccesslistpage: path(ROOTS_CoE, '/report/moduleroleaccesslistpage'),
        ytddumpreportpage: path(ROOTS_CoE, '/report/ytddumpreportpage'),
    },

    data: {
        root: path(ROOTS_CoE, '/data'),
        datapage: path(ROOTS_CoE, '/datapage'),
        inventorypage: path(ROOTS_CoE, '/data/inventorypage'),
        grosssalepage: path(ROOTS_CoE, '/data/grosssalepage'),
    }

    /*  configuration: {
          // configuration
          root: path(ROOTS_MAIN, '/configuration'),
          datauploadtemplatemapping: path(ROOTS_MAIN, '/configuration/datauploadtemplatemapping'),
          snstemplatemapping: path(ROOTS_MAIN, '/configuration/snstemplatemapping'),
      },  */

};

export const PATH_SalesUser = {
    root: ROOTS_SalesUser,
    salesdashboard: path(ROOTS_SalesUser, '/salesdashboard'),
    dataUploadApprove: path(ROOTS_SalesUser, '/datauploadapprove'),
    dealerlistpage: path(ROOTS_SalesUser, '/dealerlistpage'),
    dashboardparameter: path(ROOTS_SalesUser, '/dashboard/dashboardparameter'),
    allproducts: path(ROOTS_SalesUser, '/dashboard/allproducts'),
    allcustomers: path(ROOTS_SalesUser, '/dashboard/allcustomers'),
    readonlymaster: {
        // Masters
        root: path(ROOTS_SalesUser, '/readonlymaster'),
        product: path(ROOTS_SalesUser, '/readonlymaster/product'),
        distributor: path(ROOTS_SalesUser, '/readonlymaster/distributor'),
        account: path(ROOTS_SalesUser, '/readonlymaster/account'),
        surgeon: path(ROOTS_SalesUser, '/readonlymaster/surgeon'),
        accountterritory: path(ROOTS_SalesUser, '/readonlymaster/accountterritory'),
    },
    myreport:
    {
        root: path(ROOTS_SalesUser, '/myreport'),
        reportpage: path(ROOTS_SalesUser, '/myreportpage'),
        salesreportpage: path(ROOTS_SalesUser, '/myreport/salesreportpage'),
    },
    report: {
        root: path(ROOTS_SalesUser, '/report'),
        reportpage: path(ROOTS_SalesUser, '/reportpage'),
        transactionreportpage: path(ROOTS_SalesUser, '/report/transactionreportpage'),
        dealerreportpage: path(ROOTS_SalesUser, '/report/dealerreportpage'),
        dumpreportpage: path(ROOTS_SalesUser, '/report/dumpreportpage'),
        salesreportpage: path(ROOTS_SalesUser, '/report/salesreportpage'),
        dealerdatastatusreportpage: path(ROOTS_SalesUser, '/report/dealerstatusdatareportpage'),
        dealerreportedsnsreportpage: path(ROOTS_SalesUser, '/report/dealerreportedsnsreportpage'),
        dealersnsreportpage: path(ROOTS_SalesUser, '/report/dealersnsreportpage'),
        grosssalesreportpage: path(ROOTS_SalesUser, '/report/grosssalesreportpage'),
        ytddumpreportpage: path(ROOTS_SalesUser, '/report/ytddumpreportpage'),
    },
    data: {
        root: path(ROOTS_SalesUser, '/data'),
        datapage: path(ROOTS_SalesUser, '/datapage'),
        inventorypage: path(ROOTS_SalesUser, '/data/inventorypage'),
        grosssalepage: path(ROOTS_SalesUser, '/data/grosssalepage'),
    }
};

export const PATH_ManagerUser = {
    root: path(ROOTS_ManagerUser, '/report'),
    report: {
        root: path(ROOTS_ManagerUser, '/report'),
        reportpage: path(ROOTS_ManagerUser, '/reportpage'),
        transactionreportpage: path(ROOTS_ManagerUser, '/report/transactionreportpage'),
        dealerreportpage: path(ROOTS_ManagerUser, '/report/dealerreportpage'),

    }
};

export const changePass =
{
    root: "/changepassword"
}

export const PATH_DashboardParam = {
    root: ROOTS_DashboardParam,
    dashboardparameter: path(ROOTS_DashboardParam, '/dashboardparameter'),
    transactionreport: path(ROOTS_DashboardParam, '/reports/transactionreport'),
    dumpreport: path(ROOTS_DashboardParam, '/reports/dumpreport'),
    dealerpurchasereport: path(ROOTS_DashboardParam, '/reports/dealerpurchasereport'),
    inventoryreport: path(ROOTS_DashboardParam, '/reports/inventoryreport'),
    activitylog: path(ROOTS_DashboardParam, '/reports/activitylog'),
    allproducts: path(ROOTS_DashboardParam, '/allproducts'),
    allcustomers: path(ROOTS_DashboardParam, '/allcustomers'),
    helpandcommunication: path(ROOTS_DashboardParam, '/helpandcommunication'),
    dealersnsreport: path(ROOTS_DashboardParam, '/dealersnsreport'),
    grosssalesreport: path(ROOTS_DashboardParam, '/grosssalesreport'),
    standardpricereport: path(ROOTS_DashboardParam, '/standardpricereport'),
    moduleroleaccesslist: path(ROOTS_DashboardParam, '/moduleroleaccesslist'),
    grosssaledetailedreportexport: path(ROOTS_DashboardParam, '/grosssaledetailedreportexport'),
    ytddumpreport: path(ROOTS_DashboardParam, '/ytddumpreport'),
};

export const PATH_HelpAndCommunication = {

    root: ROOTS_HelpAndCommunication,
    helpandcommunication: (title) => path(ROOTS_HelpAndCommunication, `/home/${title}`),
    helpandcommunicationsub: (title, subcategoryname) => path(ROOTS_HelpAndCommunication, `/home/${title}/${subcategoryname}`),
    helpandcommunicationviewpage: (title, menuname) => path(ROOTS_HelpAndCommunication, `/details/${title}/qmenu/${menuname}`),
    helpandcommunicationviewpageone: (title) => path(ROOTS_HelpAndCommunication, `/details/${title}`),
    helpcommunicationsearchpage: path(ROOTS_HelpAndCommunication, '/searchedresults'),
    helpcommunicationsearchpagesub: (subcategoryname) => path(ROOTS_HelpAndCommunication, `/searchedresults/${subcategoryname}`),

};

export const PATH_Admin = {
    root: ROOTS_Admin,
    helpcategory: path(ROOTS_Admin, '/helpcategory'),
    tags: path(ROOTS_Admin, '/tags'),
    helptopics: path(ROOTS_Admin, '/helptopics'),
    subcategory: path(ROOTS_Admin, '/subcategory'),
    helpmenus: path(ROOTS_Admin, '/helpmenus'),
    addedithelptopics: path(ROOTS_Admin, '/helptopics/addedithelptopics'),
    addeditsubcategory: path(ROOTS_Admin, '/subcategory/addeditsubcategory'),
    subroot: (mainMasterName) => path(ROOTS_Admin, `/${mainMasterName}`),

    importStepOne: (mainMasterName, subMasterName) => path(ROOTS_Admin, `/${subMasterName}/stepone`),

    importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_Admin, `/${subMasterName}/stepthree`),
};

// Added by Summaya 28-11-2023

export const PATH_NetRetail = {
    root: ROOTS_NetRetail,
    netRetail: {
        root: path(ROOTS_NetRetail, '/netretail'),
        dsr_pdc_priDump: path(ROOTS_NetRetail, '/netretail/dsr_pdc_priDump'),
        dsr_pdc_priDumpStep1: path(ROOTS_NetRetail, '/netretail/dsr_pdc_priDumpStep1'),
        dsr_pdc_priDumpStep2: path(ROOTS_NetRetail, '/netretail/dsr_pdc_priDumpStep2')
    }
};

export const PATH_Supervisor = {
    root: ROOTS_Supervisor,

    netretailing: {
        // Masters
        root: path(ROOTS_Supervisor, '/netretailing'),

        //  subroot: (masterName) => path(ROOTS_MAIN, `/master/${masterName}`),
        accountverification: path(ROOTS_Supervisor, '/netretailing/accountverification'),
        transactionallocation: path(ROOTS_Supervisor, '/netretailing/transactionallocation'),

        importStepOne: (mainMasterName, subMasterName) => path(ROOTS_Supervisor, `/${mainMasterName}/${subMasterName}/stepone`),

        subroot: (mainMasterName, subMasterName) => path(ROOTS_Supervisor, `/${mainMasterName}/${subMasterName}`),

        importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_Supervisor, `/${mainMasterName}/${subMasterName}/steptwo`),

    },
};

export const PATH_BranchSecretory = {
    root: ROOTS_BS,
    bs:
    {
        home: path(ROOTS_BS, '/bs/home'),
        setrequests: path(ROOTS_BS, '/bs/setrequests'),
        createstepone: path(ROOTS_BS, '/bs/setrequests/stepone'),
        createsteptwo: path(ROOTS_BS, '/bs/setrequests/steptwo'),
        createstepthree: path(ROOTS_BS, '/bs/setrequests/stepthree'),
        createpreview: path(ROOTS_BS, '/bs/setrequests/preview'),
        history: path(ROOTS_BS, '/bs/history'),
        reports: path(ROOTS_BS, '/bs/reports'),
        analytics: path(ROOTS_BS, '/bs/analytics'),
        settings: path(ROOTS_BS, '/bs/settings'),
        bsrequestor: path(ROOTS_BS, '/bs/bsrequestor'),
        bsrequestornewset: path(ROOTS_BS, '/bs/bsrequestor/bsrequestornesetpage'),
    },
    reports:
    {
        reports: path(ROOTS_BS, '/reports/home'),

    }
};

export const PATH_NSM = {
    root: ROOTS_NSM,
    approve: {
        root: path(ROOTS_NSM, '/nsm'),
        approvestatuspage: path(ROOTS_NSM, '/nsm/setrequests/approvestatuspage'),
        home: path(ROOTS_NSM, '/nsm/home'),
        setrequests: path(ROOTS_NSM, '/nsm/setrequests')
    }
};

export const PATH_SETDEALER = {
    root: ROOTS_SETDEALER,
    dealer: {
        // root: path(ROOTS_SETDEALER, '/setdealer'),
        maindealerpage: path(ROOTS_SETDEALER, '/setdealer/maindealerpage'),
        detailsandacknowledgement: path(ROOTS_SETDEALER, '/setdealer/maindealerpage/detailsandacknowledgement')
    }
};

// Branch Secretary Added by Karishma 17-Aug-2024

export const PATH_BranchSecretaryUser = {
    root: ROOTS_BRANCHSECRETARY,
    dataUploadApprove: path(ROOTS_BRANCHSECRETARY, '/datauploadapprove'),
    dealerlistpage: path(ROOTS_BRANCHSECRETARY, '/dealerlistpage'),
    salesdashboard: path(ROOTS_BRANCHSECRETARY, '/salesdashboard'),
    dashboardparameter: path(ROOTS_BRANCHSECRETARY, '/dashboard/dashboardparameter'),
    allproducts: path(ROOTS_BRANCHSECRETARY, '/dashboard/allproducts'),
    allcustomers: path(ROOTS_BRANCHSECRETARY, '/dashboard/allcustomers'),
    readonlymaster: {
        // Masters
        root: path(ROOTS_BRANCHSECRETARY, '/readonlymaster'),
        product: path(ROOTS_BRANCHSECRETARY, '/readonlymaster/product'),
        distributor: path(ROOTS_BRANCHSECRETARY, '/readonlymaster/distributor'),
        account: path(ROOTS_BRANCHSECRETARY, '/readonlymaster/account'),
        surgeon: path(ROOTS_BRANCHSECRETARY, '/readonlymaster/surgeon'),
        empterritory: path(ROOTS_BRANCHSECRETARY, '/readonlymaster/empterritory'),
        accountterritory: path(ROOTS_BRANCHSECRETARY, '/readonlymaster/accountterritory'),
    },
    report: {
        root: path(ROOTS_BRANCHSECRETARY, '/report'),
        reportpage: path(ROOTS_BRANCHSECRETARY, '/report/reportpage'),
        dealerdatastatusreportpage: path(ROOTS_BRANCHSECRETARY, '/report/dealerstatusdatareportpage'),
        transactionreportpage: path(ROOTS_BRANCHSECRETARY, '/report/transactionreportpage'),
        dealerreportedsnsreportpage: path(ROOTS_BRANCHSECRETARY, '/report/dealerreportedsnsreportpage'),
        dealerreportpage: path(ROOTS_BRANCHSECRETARY, '/report/dealerreportpage'),
        salesreportpage: path(ROOTS_BRANCHSECRETARY, '/report/salesreportpage'),
        dumpreportpage: path(ROOTS_BRANCHSECRETARY, '/report/dumpreportpage'),
        ytddumpreportpage: path(ROOTS_BRANCHSECRETARY, '/report/ytddumpreportpage'),
    }
};

/* 
 CODE       DATE            CHANGED BY          DESCRIPTION
 CD001      05-JUN-2025     Karishma Mithari    Changes to add new layout for all pages
*/

// Started CD001
export const PATH_AllPages = {
    root: ROOTS_AllPages,
    dataUploadApprove: path(ROOTS_AllPages, '/datauploadapprove'),
    reloadzylemdata: path(ROOTS_AllPages, '/reloadzylemdata'),
    coedataupload: path(ROOTS_AllPages, '/coedataupload'),
    coedatauploadstepone: path(ROOTS_AllPages, '/coedataupload/coedatauploadstepone'),
    coedatauploadsteptwo: path(ROOTS_AllPages, '/coedataupload/coedatauploadsteptwo'),
    coedatauploadmain: path(ROOTS_AllPages, '/coedataupload/coedatauploadmain'),
    dataupload: path(ROOTS_AllPages, '/dataupload'),
    dataMappingApprove: path(ROOTS_AllPages, '/datamappingapprove'),
    datamapping: path(ROOTS_AllPages, '/datamapping'),
    datamappingproductpage: path(ROOTS_AllPages, '/datamapping/datamappingproductpage'),
    datamappingaccountpage: path(ROOTS_AllPages, '/datamapping/datamappingaccountpage'),
    datamappingsurgeonpage: path(ROOTS_AllPages, '/datamapping/datamappingsurgeonpage'),
    datamappingimportstep1: path(ROOTS_AllPages, `/datamapping/datamappingimportstep1`),
    datamappingimportstep2: (importName) => path(ROOTS_AllPages, `/datamapping/${importName}/datamappingimportstep2`),
    datamappingimportstep3: (importName) => path(ROOTS_AllPages, `/datamapping/${importName}/datamappingimportstep3`),
    datamappingdownloadstep2: (importName) => path(ROOTS_AllPages, `/datamapping/${importName}/datamappingdownloadstep2`),
    enablereupload: path(ROOTS_AllPages, '/enablereupload'),
    dealerrequest: path(ROOTS_AllPages, '/dealerrequest'),
    dealeraccountrequest: path(ROOTS_AllPages, '/dealerrequest/dealeraccountrequest'),
    dealersugeonrequest: path(ROOTS_AllPages, '/dealerrequest/dealersugeonrequest'),
    raiseticketrequest: path(ROOTS_AllPages, '/raiseticketrequest/raiseticketpage'),
    configuration: path(ROOTS_AllPages, '/configuration'),
    cutoffdatepage: path(ROOTS_AllPages, '/cutoffdatepage'),
    salesdashboard: path(ROOTS_AllPages, '/salesdashboard'),
    dealerlistpage: path(ROOTS_AllPages, '/dealerlistpage'),
    dashboardparameter: path(ROOTS_AllPages, '/dashboard/dashboardparameter'),
    allproducts: path(ROOTS_AllPages, '/dashboard/allproducts'),
    allcustomers: path(ROOTS_AllPages, '/dashboard/allcustomers'),
    helpcategory: path(ROOTS_AllPages, '/helpcategory'),
    tags: path(ROOTS_AllPages, '/tags'),
    helptopics: path(ROOTS_AllPages, '/helptopics'),
    subcategory: path(ROOTS_AllPages, '/subcategory'),
    addedithelptopics: path(ROOTS_AllPages, '/helptopics/addedithelptopics'),
    addeditsubcategory: path(ROOTS_AllPages, '/subcategory/addeditsubcategory'),
    // subroot: (mainMasterName) => path(ROOTS_AllPages, `/${mainMasterName}`),
    // importStepOne: (mainMasterName, subMasterName) => path(ROOTS_AllPages, `/${subMasterName}/stepone`),
    // importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_AllPages, `/${subMasterName}/stepthree`),

    subroot: (mainMasterName, subMasterName) => path(ROOTS_AllPages, `/${mainMasterName}/${subMasterName}`),
    importStepOne: (mainMasterName, subMasterName) => path(ROOTS_AllPages, `/${mainMasterName}/${subMasterName}/stepone`),
    importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_AllPages, `/${mainMasterName}/${subMasterName}/stepthree`),

    adminMaster: (masterName) => path(ROOTS_AllPages, `/${masterName}`),
    adminStepOne: (masterName) => path(ROOTS_AllPages, `/${masterName}/stepone`),
    adminStepTwo: (masterName) => path(ROOTS_AllPages, `/${masterName}/stepthree`),

    master: {
        // Masters
        root: path(ROOTS_AllPages, '/master'),
        product: path(ROOTS_AllPages, '/master/product'),
        ecpproduct: path(ROOTS_AllPages, '/master/ecpproduct'),
        distributor: path(ROOTS_AllPages, '/master/distributor'),
        account: path(ROOTS_AllPages, '/master/account'),
        surgeon: path(ROOTS_AllPages, '/master/surgeon'),
        areatree: path(ROOTS_AllPages, '/master/areatree'),
        empmaster: path(ROOTS_AllPages, '/master/empmaster'),
        territory: path(ROOTS_AllPages, '/master/territory'),
        empterritory: path(ROOTS_AllPages, '/master/empterritory'),
        empregion: path(ROOTS_AllPages, '/master/empregion'),
        accountterritory: path(ROOTS_AllPages, '/master/accountterritory'),
        distributorterritory: path(ROOTS_AllPages, '/master/distributorterritory'),
        territoryhierarchy: path(ROOTS_AllPages, '/master/territoryhierarchy'),
        orggroupdefinition: path(ROOTS_AllPages, '/master/orggroupdefinition'),
        dealeragreementexpiry: path(ROOTS_AllPages, '/master/dealeragreementexpiry'),
        dealerrating: path(ROOTS_AllPages, '/master/dealerrating'),
        standardpricemaster: path(ROOTS_AllPages, '/master/standardpricemaster'),
        distributorbillingsoftware: path(ROOTS_AllPages, '/master/distributorbillingsoftware'),
        customers: path(ROOTS_AllPages, '/master/customers'),
        customeraccount: path(ROOTS_AllPages, '/master/customeraccount'),
    },

    alliedmaster: {
        // Allied masters
        root: path(ROOTS_AllPages, '/alliedmaster'),
        distributorgroup: path(ROOTS_AllPages, '/alliedmaster/distributorgroup'),
        uom: path(ROOTS_AllPages, '/alliedmaster/uom'),
        franchise: path(ROOTS_AllPages, '/alliedmaster/franchise'),
        subfranchise: path(ROOTS_AllPages, '/alliedmaster/subfranchise'),
        productgroup: path(ROOTS_AllPages, '/alliedmaster/productgroup'),
        productcategory: path(ROOTS_AllPages, '/alliedmaster/productcategory'),
        productbrand: path(ROOTS_AllPages, '/alliedmaster/productbrand'),
        productline: path(ROOTS_AllPages, '/alliedmaster/productline'),
        accountgroup: path(ROOTS_AllPages, '/alliedmaster/accountgroup'),
        accounttype: path(ROOTS_AllPages, '/alliedmaster/accounttype'),
        accountclassification: path(ROOTS_AllPages, '/alliedmaster/accountclassification'),
        accountsegmentation: path(ROOTS_AllPages, '/alliedmaster/accountsegmentation'),
        accountcategory: path(ROOTS_AllPages, '/alliedmaster/accountcategory'),
        surgeoncontacttype: path(ROOTS_AllPages, '/alliedmaster/surgeoncontacttype'),
        surgeonsubcontacttype: path(ROOTS_AllPages, '/alliedmaster/surgeonsubcontacttype'),
        citytier: path(ROOTS_AllPages, '/alliedmaster/citytier'),
        emplevel: path(ROOTS_AllPages, '/alliedmaster/emplevel'),
        specialist: path(ROOTS_AllPages, '/alliedmaster/specialist'),
        bravohierarchy: path(ROOTS_AllPages, '/alliedmaster/bravohierarchy'),
    },

    data: {
        root: path(ROOTS_AllPages, '/data'),
        datapage: path(ROOTS_AllPages, '/datapage'),
        inventorypage: path(ROOTS_AllPages, '/data/inventorypage'),
        grosssalepage: path(ROOTS_AllPages, '/data/grosssalepage'),
    },

    report: {
        root: path(ROOTS_AllPages, '/report'),
        reportpage: path(ROOTS_AllPages, '/reportpage'),
        transactionreportpage: path(ROOTS_AllPages, '/report/transactionreportpage'),
        dealerreportpage: path(ROOTS_AllPages, '/report/dealerreportpage'),
        dumpreportpage: path(ROOTS_AllPages, '/report/dumpreportpage'),
        territorydumpreportpage: path(ROOTS_AllPages, '/report/territorydumpreportpage'),
        dealerpurchasereportpage: path(ROOTS_AllPages, '/report/dealerpurchasereportpage'),
        inventoryreportpage: path(ROOTS_AllPages, '/report/inventoryreportpage'),
        activitylogpage: path(ROOTS_AllPages, '/report/activitylogpage'),
        dealerdatastatusreportpage: path(ROOTS_AllPages, '/report/dealerstatusdatareportpage'),
        dealerreportedsnsreportpage: path(ROOTS_AllPages, '/report/dealerreportedsnsreportpage'),
        standardpricereportpage: path(ROOTS_AllPages, '/report/standardpricereportpage'),
        moduleroleaccesslistpage: path(ROOTS_AllPages, '/report/moduleroleaccesslistpage'),
        ytddumpreportpage: path(ROOTS_AllPages, '/report/ytddumpreportpage'),
        salesreportpage: path(ROOTS_AllPages, '/report/salesreportpage'),
    },
};

export const PATH_COEAdmin = {
    root: ROOTS_CoE,
    dataUploadApprove: path(ROOTS_CoE, '/datauploadapprove'),
    reloadzylemdata: path(ROOTS_CoE, '/reloadzylemdata'),
    coedataupload: path(ROOTS_CoE, '/coedataupload'),
    coedatauploadstepone: path(ROOTS_CoE, '/coedataupload/coedatauploadstepone'),
    coedatauploadsteptwo: path(ROOTS_CoE, '/coedataupload/coedatauploadsteptwo'),
    coedatauploadmain: path(ROOTS_CoE, '/coedataupload/coedatauploadmain'),
    dataupload: path(ROOTS_CoE, '/dataupload'),
    dataMappingApprove: path(ROOTS_CoE, '/datamappingapprove'),
    noneligiblerecordsapprove: path(ROOTS_CoE, '/noneligiblerecordsapprove'),
    datamapping: path(ROOTS_CoE, '/datamapping'),
    datamappingproductpage: path(ROOTS_CoE, '/datamapping/datamappingproductpage'),
    datamappingaccountpage: path(ROOTS_CoE, '/datamapping/datamappingaccountpage'),
    datamappingsurgeonpage: path(ROOTS_CoE, '/datamapping/datamappingsurgeonpage'),
    datamappingimportstep1: path(ROOTS_CoE, `/datamapping/datamappingimportstep1`),
    datamappingimportstep2: (importName) => path(ROOTS_CoE, `/datamapping/${importName}/datamappingimportstep2`),
    datamappingimportstep3: (importName) => path(ROOTS_CoE, `/datamapping/${importName}/datamappingimportstep3`),
    datamappingdownloadstep2: (importName) => path(ROOTS_CoE, `/datamapping/${importName}/datamappingdownloadstep2`),
    enablereupload: path(ROOTS_CoE, '/enablereupload'),
    dealerrequest: path(ROOTS_CoE, '/dealerrequest'),
    dealeraccountrequest: path(ROOTS_CoE, '/dealerrequest/dealeraccountrequest'),
    dealersugeonrequest: path(ROOTS_CoE, '/dealerrequest/dealersugeonrequest'),
    raiseticketrequest: path(ROOTS_CoE, '/raiseticketrequest/raiseticketpage'),

    subroot: (mainMasterName, subMasterName) => path(ROOTS_CoE, `/${mainMasterName}/${subMasterName}`),

    importStepOne: (mainMasterName, subMasterName) => path(ROOTS_CoE, `/${mainMasterName}/${subMasterName}/stepone`),

    importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_CoE, `/${mainMasterName}/${subMasterName}/stepthree`),

    master: {
        // Masters
        root: path(ROOTS_CoE, '/master'),

        //  subroot: (masterName) => path(ROOTS_MAIN, `/master/${masterName}`),
        product: path(ROOTS_CoE, '/master/product'),
        ecpproduct: path(ROOTS_CoE, '/master/ecpproduct'),
        distributor: path(ROOTS_CoE, '/master/distributor'),
        account: path(ROOTS_CoE, '/master/account'),
        surgeon: path(ROOTS_CoE, '/master/surgeon'),
        areatree: path(ROOTS_CoE, '/master/areatree'),
        saleshierarchy: path(ROOTS_CoE, '/master/saleshierarchy'),
        netrealizationrate: path(ROOTS_CoE, '/master/nrr'),
        fieldstaffallocation: path(ROOTS_CoE, '/master/fieldstaffallocation'),
        empmaster: path(ROOTS_CoE, '/master/empmaster'),
        territory: path(ROOTS_CoE, '/master/territory'),
        empterritory: path(ROOTS_CoE, '/master/empterritory'),
        empregion: path(ROOTS_CoE, '/master/empregion'),
        accountterritory: path(ROOTS_CoE, '/master/accountterritory'),
        distributorterritory: path(ROOTS_CoE, '/master/distributorterritory'),
        territoryhierarchy: path(ROOTS_CoE, '/master/territoryhierarchy'),
        orggroupdefinition: path(ROOTS_CoE, '/master/orggroupdefinition'),
        dealeragreementexpiry: path(ROOTS_CoE, '/master/dealeragreementexpiry'),
        dealerrating: path(ROOTS_CoE, '/master/dealerrating'),
        standardpricemaster: path(ROOTS_CoE, '/master/standardpricemaster'),
        distributorbillingsoftware: path(ROOTS_CoE, '/master/distributorbillingsoftware'),
        customers: path(ROOTS_CoE, '/master/customers'),
        customeraccount: path(ROOTS_CoE, '/master/customeraccount'),

        // user: path(ROOTS_MAIN, '/master/usermaster'),
        usermasterlist: path(ROOTS_CoE, '/master/usermasterlist'),
        userdata: path(ROOTS_CoE, '/master/userdata'),
        customersalesteam: path(ROOTS_CoE, '/master/customersalesteam'),
        useraccessrights: path(ROOTS_CoE, '/master/useraccessrights'),
        productvariant: path(ROOTS_CoE, '/master/productvariant'),
    },

    alliedmaster: {
        // Allied masters
        root: path(ROOTS_CoE, '/alliedmaster'),
        //  subroot: (masterName) => path(ROOTS_MAIN, `/alliedmaster/${masterName}`),

        distributorgroup: path(ROOTS_CoE, '/alliedmaster/distributorgroup'),
        uom: path(ROOTS_CoE, '/alliedmaster/uom'),
        franchise: path(ROOTS_CoE, '/alliedmaster/franchise'),
        subfranchise: path(ROOTS_CoE, '/alliedmaster/subfranchise'),
        productgroup: path(ROOTS_CoE, '/alliedmaster/productgroup'),
        productcategory: path(ROOTS_CoE, '/alliedmaster/productcategory'),
        productbrand: path(ROOTS_CoE, '/alliedmaster/productbrand'),
        productline: path(ROOTS_CoE, '/alliedmaster/productline'),
        accountgroup: path(ROOTS_CoE, '/alliedmaster/accountgroup'),
        accounttype: path(ROOTS_CoE, '/alliedmaster/accounttype'),
        accountclassification: path(ROOTS_CoE, '/alliedmaster/accountclassification'),
        accountsegmentation: path(ROOTS_CoE, '/alliedmaster/accountsegmentation'),
        accountcategory: path(ROOTS_CoE, '/alliedmaster/accountcategory'),
        surgeoncontacttype: path(ROOTS_CoE, '/alliedmaster/surgeoncontacttype'),
        surgeonsubcontacttype: path(ROOTS_CoE, '/alliedmaster/surgeonsubcontacttype'),
        citytier: path(ROOTS_CoE, '/alliedmaster/citytier'),
        // territory: path(ROOTS_CoE, '/alliedmaster/territory'),
        emplevel: path(ROOTS_CoE, '/alliedmaster/emplevel'),
        specialist: path(ROOTS_CoE, '/alliedmaster/specialist'),
        bravohierarchy: path(ROOTS_CoE, '/alliedmaster/bravohierarchy'),
    },

    // configuration
    configuration: path(ROOTS_CoE, '/configuration'),
    cutoffdatepage: path(ROOTS_CoE, '/cutoffdatepage'),
    franchisewisecutoff: path(ROOTS_CoE, '/franchisewisecutoff'),
    myreport:
    {
        root: path(ROOTS_CoE, '/myreport'),
        reportpage: path(ROOTS_CoE, '/myreportpage'),
        territorydumpreportpage: path(ROOTS_CoE, '/myreport/territorydumpreportpage'),

    },
    report: {
        root: path(ROOTS_CoE, '/report'),
        reportpage: path(ROOTS_CoE, '/reportpage'),
        transactionreportpage: path(ROOTS_CoE, '/report/transactionreportpage'),
        dealerreportpage: path(ROOTS_CoE, '/report/dealerreportpage'),
        dumpreportpage: path(ROOTS_CoE, '/report/dumpreportpage'),
        territorydumpreportpage: path(ROOTS_CoE, '/report/territorydumpreportpage'),
        dealerpurchasereportpage: path(ROOTS_CoE, '/report/dealerpurchasereportpage'),
        inventoryreportpage: path(ROOTS_CoE, '/report/inventoryreportpage'),
        activitylogpage: path(ROOTS_CoE, '/report/activitylogpage'),
        dealerdatastatusreportpage: path(ROOTS_CoE, '/report/dealerstatusdatareportpage'),
        dealerreportedsnsreportpage: path(ROOTS_CoE, '/report/dealerreportedsnsreportpage'),
        dealersnsreportpage: path(ROOTS_CoE, '/report/dealersnsreportpage'),
        grosssalesreportpage: path(ROOTS_CoE, '/report/grosssalesreportpage'),
        standardpricereportpage: path(ROOTS_CoE, '/report/standardpricereportpage'),
        moduleroleaccesslistpage: path(ROOTS_CoE, '/report/moduleroleaccesslistpage'),
        ytddumpreportpage: path(ROOTS_CoE, '/report/ytddumpreportpage'),
    },

    data: {
        root: path(ROOTS_CoE, '/data'),
        datapage: path(ROOTS_CoE, '/datapage'),
        inventorypage: path(ROOTS_CoE, '/data/inventorypage'),
        grosssalepage: path(ROOTS_CoE, '/data/grosssalepage'),
    }

    /*  configuration: {
          // configuration
          root: path(ROOTS_MAIN, '/configuration'),
          datauploadtemplatemapping: path(ROOTS_MAIN, '/configuration/datauploadtemplatemapping'),
          snstemplatemapping: path(ROOTS_MAIN, '/configuration/snstemplatemapping'),
      },  */

};

export const PATH_ReportUser = {
    root: ROOTS_ReportUser,
    data: {
        root: path(ROOTS_ReportUser, '/data'),
        datapage: path(ROOTS_ReportUser, '/datapage'),
        inventorypage: path(ROOTS_ReportUser, '/data/inventorypage'),
        grosssalepage: path(ROOTS_ReportUser, '/data/grosssalepage'),
    },
    report: {
        root: path(ROOTS_ReportUser, '/report'),
        reportpage: path(ROOTS_ReportUser, '/reportpage'),
        dealerdatastatusreportpage: path(ROOTS_ReportUser, '/report/dealerstatusdatareportpage'),
        transactionreportpage: path(ROOTS_ReportUser, '/report/transactionreportpage'),
        dealerreportedsnsreportpage: path(ROOTS_ReportUser, '/report/dealerreportedsnsreportpage'),
        dealerreportpage: path(ROOTS_ReportUser, '/report/dealerreportpage'),
        mysalesreportpage: path(ROOTS_ReportUser, '/report/mysalesreportpage'),
        ytddumpreportpage: path(ROOTS_ReportUser, '/report/ytddumpreportpage'),
    }
};

export const PATH_DashboardAndReportUser = {
    root: ROOTS_DashboardAndReportUser,
    dataUploadApprove: path(ROOTS_DashboardAndReportUser, '/datauploadapprove'),
    dealerlistpage: path(ROOTS_DashboardAndReportUser, '/dealerlistpage'),
    salesdashboard: path(ROOTS_DashboardAndReportUser, '/salesdashboard'),

    master: {
        // Masters
        root: path(ROOTS_DashboardAndReportUser, '/master'),
        product: path(ROOTS_DashboardAndReportUser, '/master/product'),
        ecpproduct: path(ROOTS_DashboardAndReportUser, '/master/ecpproduct'),
        distributor: path(ROOTS_DashboardAndReportUser, '/master/distributor'),
        account: path(ROOTS_DashboardAndReportUser, '/master/account'),
        surgeon: path(ROOTS_DashboardAndReportUser, '/master/surgeon'),
        areatree: path(ROOTS_DashboardAndReportUser, '/master/areatree'),
        empmaster: path(ROOTS_DashboardAndReportUser, '/master/empmaster'),
        territory: path(ROOTS_DashboardAndReportUser, '/master/territory'),
        empterritory: path(ROOTS_DashboardAndReportUser, '/master/empterritory'),
        empregion: path(ROOTS_DashboardAndReportUser, '/master/empregion'),
        accountterritory: path(ROOTS_DashboardAndReportUser, '/master/accountterritory'),
        distributorterritory: path(ROOTS_DashboardAndReportUser, '/master/distributorterritory'),
        territoryhierarchy: path(ROOTS_DashboardAndReportUser, '/master/territoryhierarchy'),
        orggroupdefinition: path(ROOTS_DashboardAndReportUser, '/master/orggroupdefinition'),
        dealeragreementexpiry: path(ROOTS_DashboardAndReportUser, '/master/dealeragreementexpiry'),
        dealerrating: path(ROOTS_DashboardAndReportUser, '/master/dealerrating'),
        standardpricemaster: path(ROOTS_DashboardAndReportUser, '/master/standardpricemaster'),
        distributorbillingsoftware: path(ROOTS_DashboardAndReportUser, '/master/distributorbillingsoftware'),
        customers: path(ROOTS_DashboardAndReportUser, '/master/customers'),
        customeraccount: path(ROOTS_DashboardAndReportUser, '/master/customeraccount'),
    },
    data: {
        root: path(ROOTS_DashboardAndReportUser, '/data'),
        datapage: path(ROOTS_DashboardAndReportUser, '/datapage'),
        inventorypage: path(ROOTS_DashboardAndReportUser, '/data/inventorypage'),
        grosssalepage: path(ROOTS_DashboardAndReportUser, '/data/grosssalepage'),
    },
    report: {
        root: path(ROOTS_DashboardAndReportUser, '/report'),
        reportpage: path(ROOTS_DashboardAndReportUser, '/reportpage'),
        dealerdatastatusreportpage: path(ROOTS_DashboardAndReportUser, '/report/dealerstatusdatareportpage'),
        transactionreportpage: path(ROOTS_DashboardAndReportUser, '/report/transactionreportpage'),
        dealerreportedsnsreportpage: path(ROOTS_DashboardAndReportUser, '/report/dealerreportedsnsreportpage'),
        dealerreportpage: path(ROOTS_DashboardAndReportUser, '/report/dealerreportpage'),
        salesreportpage: path(ROOTS_DashboardAndReportUser, '/report/salesreportpage'),
        ytddumpreportpage: path(ROOTS_DashboardAndReportUser, '/report/ytddumpreportpage'),
    }
};

export const PATH_MasterUser = {
    root: ROOTS_MasterUser,
    dataUploadApprove: path(ROOTS_MasterUser, '/datauploadapprove'),
    reloadzylemdata: path(ROOTS_MasterUser, '/reloadzylemdata'),
    datamapping: path(ROOTS_MasterUser, '/datamapping'),
    datamappingproductpage: path(ROOTS_MasterUser, '/datamapping/datamappingproductpage'),
    datamappingaccountpage: path(ROOTS_MasterUser, '/datamapping/datamappingaccountpage'),
    datamappingsurgeonpage: path(ROOTS_MasterUser, '/datamapping/datamappingsurgeonpage'),
    datamappingimportstep1: path(ROOTS_MasterUser, `/datamapping/datamappingimportstep1`),
    datamappingimportstep2: (importName) => path(ROOTS_MasterUser, `/datamapping/${importName}/datamappingimportstep2`),
    datamappingimportstep3: (importName) => path(ROOTS_MasterUser, `/datamapping/${importName}/datamappingimportstep3`),
    datamappingdownloadstep2: (importName) => path(ROOTS_MasterUser, `/datamapping/${importName}/datamappingdownloadstep2`),
    enablereupload: path(ROOTS_MasterUser, '/enablereupload'),
    configuration: path(ROOTS_MasterUser, '/configuration'),
    cutoffdatepage: path(ROOTS_MasterUser, '/cutoffdatepage'),
    franchisewisecutoff: path(ROOTS_MasterUser, '/franchisewisecutoff'),
    helpcategory: path(ROOTS_MasterUser, '/helpcategory'),
    tags: path(ROOTS_MasterUser, '/tags'),
    helptopics: path(ROOTS_MasterUser, '/helptopics'),
    subcategory: path(ROOTS_MasterUser, '/subcategory'),
    addedithelptopics: path(ROOTS_MasterUser, '/helptopics/addedithelptopics'),
    addeditsubcategory: path(ROOTS_MasterUser, '/subcategory/addeditsubcategory'),

    subroot: (mainMasterName, subMasterName) => path(ROOTS_MasterUser, `/${mainMasterName}/${subMasterName}`),
    importStepOne: (mainMasterName, subMasterName) => path(ROOTS_MasterUser, `/${mainMasterName}/${subMasterName}/stepone`),
    importStepTwo: (mainMasterName, subMasterName) => path(ROOTS_MasterUser, `/${mainMasterName}/${subMasterName}/stepthree`),

    adminMaster: (masterName) => path(ROOTS_MasterUser, `/${masterName}`),
    adminStepOne: (masterName) => path(ROOTS_MasterUser, `/${masterName}/stepone`),
    adminStepTwo: (masterName) => path(ROOTS_MasterUser, `/${masterName}/stepthree`),

    master: {
        // Masters
        root: path(ROOTS_MasterUser, '/master'),
        product: path(ROOTS_MasterUser, '/master/product'),
        ecpproduct: path(ROOTS_MasterUser, '/master/ecpproduct'),
        distributor: path(ROOTS_MasterUser, '/master/distributor'),
        account: path(ROOTS_MasterUser, '/master/account'),
        surgeon: path(ROOTS_MasterUser, '/master/surgeon'),
        areatree: path(ROOTS_MasterUser, '/master/areatree'),
        empmaster: path(ROOTS_MasterUser, '/master/empmaster'),
        territory: path(ROOTS_MasterUser, '/master/territory'),
        empterritory: path(ROOTS_MasterUser, '/master/empterritory'),
        empregion: path(ROOTS_MasterUser, '/master/empregion'),
        accountterritory: path(ROOTS_MasterUser, '/master/accountterritory'),
        distributorterritory: path(ROOTS_MasterUser, '/master/distributorterritory'),
        territoryhierarchy: path(ROOTS_MasterUser, '/master/territoryhierarchy'),
        orggroupdefinition: path(ROOTS_MasterUser, '/master/orggroupdefinition'),
        dealeragreementexpiry: path(ROOTS_MasterUser, '/master/dealeragreementexpiry'),
        dealerrating: path(ROOTS_MasterUser, '/master/dealerrating'),
        standardpricemaster: path(ROOTS_MasterUser, '/master/standardpricemaster'),
        distributorbillingsoftware: path(ROOTS_MasterUser, '/master/distributorbillingsoftware'),
        customers: path(ROOTS_MasterUser, '/master/customers'),
        customeraccount: path(ROOTS_MasterUser, '/master/customeraccount'),
    },

    alliedmaster: {
        // Allied masters
        root: path(ROOTS_MasterUser, '/alliedmaster'),
        distributorgroup: path(ROOTS_MasterUser, '/alliedmaster/distributorgroup'),
        uom: path(ROOTS_MasterUser, '/alliedmaster/uom'),
        franchise: path(ROOTS_MasterUser, '/alliedmaster/franchise'),
        subfranchise: path(ROOTS_MasterUser, '/alliedmaster/subfranchise'),
        productgroup: path(ROOTS_MasterUser, '/alliedmaster/productgroup'),
        productcategory: path(ROOTS_MasterUser, '/alliedmaster/productcategory'),
        productbrand: path(ROOTS_MasterUser, '/alliedmaster/productbrand'),
        productline: path(ROOTS_MasterUser, '/alliedmaster/productline'),
        accountgroup: path(ROOTS_MasterUser, '/alliedmaster/accountgroup'),
        accounttype: path(ROOTS_MasterUser, '/alliedmaster/accounttype'),
        accountclassification: path(ROOTS_MasterUser, '/alliedmaster/accountclassification'),
        accountsegmentation: path(ROOTS_MasterUser, '/alliedmaster/accountsegmentation'),
        accountcategory: path(ROOTS_MasterUser, '/alliedmaster/accountcategory'),
        surgeoncontacttype: path(ROOTS_MasterUser, '/alliedmaster/surgeoncontacttype'),
        surgeonsubcontacttype: path(ROOTS_MasterUser, '/alliedmaster/surgeonsubcontacttype'),
        citytier: path(ROOTS_MasterUser, '/alliedmaster/citytier'),
        emplevel: path(ROOTS_MasterUser, '/alliedmaster/emplevel'),
        specialist: path(ROOTS_MasterUser, '/alliedmaster/specialist'),
        bravohierarchy: path(ROOTS_MasterUser, '/alliedmaster/bravohierarchy'),
    },
};

export const PATH_MasterViewer = {
    root: ROOTS_MasterViewer,
    dataUploadApprove: path(ROOTS_MasterViewer, '/datauploadapprove'),
    reloadzylemdata: path(ROOTS_MasterViewer, '/reloadzylemdata'),
    datamapping: path(ROOTS_MasterViewer, '/datamapping'),
    datamappingproductpage: path(ROOTS_MasterViewer, '/datamapping/datamappingproductpage'),
    datamappingaccountpage: path(ROOTS_MasterViewer, '/datamapping/datamappingaccountpage'),
    datamappingsurgeonpage: path(ROOTS_MasterViewer, '/datamapping/datamappingsurgeonpage'),
    datamappingimportstep1: path(ROOTS_MasterViewer, `/datamapping/datamappingimportstep1`),
    datamappingimportstep2: (importName) => path(ROOTS_MasterViewer, `/datamapping/${importName}/datamappingimportstep2`),
    datamappingimportstep3: (importName) => path(ROOTS_MasterViewer, `/datamapping/${importName}/datamappingimportstep3`),
    datamappingdownloadstep2: (importName) => path(ROOTS_MasterViewer, `/datamapping/${importName}/datamappingdownloadstep2`),
    enablereupload: path(ROOTS_MasterViewer, '/enablereupload'),
    configuration: path(ROOTS_MasterViewer, '/configuration'),
    cutoffdatepage: path(ROOTS_MasterViewer, '/cutoffdatepage'),
    franchisewisecutoff: path(ROOTS_MasterViewer, '/franchisewisecutoff'),

    master: {
        // Masters
        root: path(ROOTS_MasterViewer, '/master'),
        product: path(ROOTS_MasterViewer, '/master/product'),
        ecpproduct: path(ROOTS_MasterViewer, '/master/ecpproduct'),
        distributor: path(ROOTS_MasterViewer, '/master/distributor'),
        account: path(ROOTS_MasterViewer, '/master/account'),
        surgeon: path(ROOTS_MasterViewer, '/master/surgeon'),
        areatree: path(ROOTS_MasterViewer, '/master/areatree'),
        empmaster: path(ROOTS_MasterViewer, '/master/empmaster'),
        territory: path(ROOTS_MasterViewer, '/master/territory'),
        empterritory: path(ROOTS_MasterViewer, '/master/empterritory'),
        empregion: path(ROOTS_MasterViewer, '/master/empregion'),
        accountterritory: path(ROOTS_MasterViewer, '/master/accountterritory'),
        distributorterritory: path(ROOTS_MasterViewer, '/master/distributorterritory'),
        territoryhierarchy: path(ROOTS_MasterViewer, '/master/territoryhierarchy'),
        orggroupdefinition: path(ROOTS_MasterViewer, '/master/orggroupdefinition'),
        dealeragreementexpiry: path(ROOTS_MasterViewer, '/master/dealeragreementexpiry'),
        dealerrating: path(ROOTS_MasterViewer, '/master/dealerrating'),
        standardpricemaster: path(ROOTS_MasterViewer, '/master/standardpricemaster'),
        distributorbillingsoftware: path(ROOTS_MasterViewer, '/master/distributorbillingsoftware'),
        customers: path(ROOTS_MasterViewer, '/master/customers'),
        customeraccount: path(ROOTS_MasterViewer, '/master/customeraccount'),
    },

    alliedmaster: {
        // Allied masters
        root: path(ROOTS_MasterViewer, '/alliedmaster'),
        distributorgroup: path(ROOTS_MasterViewer, '/alliedmaster/distributorgroup'),
        uom: path(ROOTS_MasterViewer, '/alliedmaster/uom'),
        franchise: path(ROOTS_MasterViewer, '/alliedmaster/franchise'),
        subfranchise: path(ROOTS_MasterViewer, '/alliedmaster/subfranchise'),
        productgroup: path(ROOTS_MasterViewer, '/alliedmaster/productgroup'),
        productcategory: path(ROOTS_MasterViewer, '/alliedmaster/productcategory'),
        productbrand: path(ROOTS_MasterViewer, '/alliedmaster/productbrand'),
        productline: path(ROOTS_MasterViewer, '/alliedmaster/productline'),
        accountgroup: path(ROOTS_MasterViewer, '/alliedmaster/accountgroup'),
        accounttype: path(ROOTS_MasterViewer, '/alliedmaster/accounttype'),
        accountclassification: path(ROOTS_MasterViewer, '/alliedmaster/accountclassification'),
        accountsegmentation: path(ROOTS_MasterViewer, '/alliedmaster/accountsegmentation'),
        accountcategory: path(ROOTS_MasterViewer, '/alliedmaster/accountcategory'),
        surgeoncontacttype: path(ROOTS_MasterViewer, '/alliedmaster/surgeoncontacttype'),
        surgeonsubcontacttype: path(ROOTS_MasterViewer, '/alliedmaster/surgeonsubcontacttype'),
        citytier: path(ROOTS_MasterViewer, '/alliedmaster/citytier'),
        emplevel: path(ROOTS_MasterViewer, '/alliedmaster/emplevel'),
        specialist: path(ROOTS_MasterViewer, '/alliedmaster/specialist'),
        bravohierarchy: path(ROOTS_MasterViewer, '/alliedmaster/bravohierarchy'),
    },
};
// ended CD001